import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { PeriodSubForm, Schema as PeriodSchema } from '../subforms/Period';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const MoehrleYoungTalentsSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(PeriodSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const MoehrleYoungTalents = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={PeriodSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}